import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchReports = async ({ queryKey }) => {
  const [, query] = queryKey; // The second element is your searchQuery object
  const { data } = await apiClient.get(`/jobs`, {
    params: {
      ...query,
    },
  });

  return data;
};

export const useGetDocumentReportsHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [reports, setReports] = useState([]);
  const [totalReports, setTotalReports] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['jobs', { ...searchQuery }], // A unique key for this query
    queryFn: fetchReports,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (fetchedData) {
      setReports(fetchedData.content);
      setTotalReports(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    reports,
    totalReports,
    isLoading,
  };
};
